App.filter('dateFormatterDay', function () {
    return function (miliSec) {
        miliSec = miliSec || '';
        if (miliSec) {
            var time = new Date(miliSec);

            var day = time.getDate();

            var all = day;
        }
        return all;
    };
})